module.exports = __webpack_public_path__ + "static/media/ice32.a21e0e3b.webp";